export default {
    FETCH_LIST_DATA(state, payload){
        state.listLogs  = payload
    }
}